import type { NodeParamBase } from '../types/NodeParamBase';
import { NodeParamTypes } from '../types/NodeParamTypes';

export const formatNodeParam = (param: NodeParamBase): string => {
  const objectString = param.type === NodeParamTypes.Object ? `{${param.name}}` : param.name;
  return param.isArray ? `[${objectString}]` : objectString;
};
